module.exports = __webpack_public_path__ + "img/qrcode_icon.44e2447a.png";